import { Box, IconButton, Stack, Divider, Grid } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CustomText from 'components/common/CustomText/CustomText';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomFormTextInput from 'components/inputs/CustomFormTextInput/CustomFormTextInput';
import useGlobalStyles from 'styles/globalStyles';
import { colors } from 'styles/colors';
import AddIcon from 'icons/AddIcon';
import useStyles from './styles';

export default function CaseNotes() {
  const { register, control, formState: { errors } } = useFormContext();
  const globalStyles = useGlobalStyles();
  const styles = useStyles();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'notes',
  });

  return (
    <Box className={globalStyles.sectionContainer}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className={globalStyles.sectionHeader}
      >
        <Stack direction="row" alignItems="center">
          <CustomText
            text="Notes"
            color={colors.primary}
            fontWeight={600}
          />
        </Stack>

        <Box mr={2}>
          <IconButton
            onClick={() => append('')}
            className={globalStyles.sectionButton}
          >
            <AddIcon size={22} color={colors.primary} />
          </IconButton>
        </Box>
      </Stack>

      {fields.length > 0 && <Divider />}

      {fields.length > 0 && <Grid container spacing={1.5} pr={2.5} pl={2.5} my={2}>
        {fields.map((field, index) => (
          <Grid size={{ xs: 12, md: 6 }} key={field.id}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Box flex={1}>
                <CustomFormTextInput
                  name={`notes.${index}`}
                  placeholder={`Note ${index + 1}`}
                  register={register}
                  error={(errors as any)?.notes?.[index]}
                  multiline
                  minRows={3}
                />
              </Box>

              <IconButton
                color="error"
                onClick={() => remove(index)}
                sx={{ padding: 0 }}
              >
                <RemoveCircleOutlineIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Stack>
          </Grid>
        ))}
      </Grid>}
    </Box>
  );
}
